import type { Region } from "../config";

/** Deployment config only. Never creates or pretends to deploy a server. */
export function parseRegions(raw: string): Record<string, Region> {
	const value: unknown = JSON.parse(raw);
	if (!value || typeof value !== "object" || Array.isArray(value))
		throw new Error("Regions must be an object");
	const entries = Object.entries(value);
	if (entries.length < 1 || entries.length > 4)
		throw new Error("Configure between one and four regions");
	const result: Record<string, Region> = {};
	for (const [id, candidate] of entries) {
		if (
			!/^[a-z][a-z0-9_-]{0,15}$/.test(id) ||
			!candidate ||
			typeof candidate !== "object"
		)
			throw new Error("Invalid region");
		const region = candidate as Partial<Region>;
		if (
			typeof region.name !== "string" ||
			!region.name.trim() ||
			region.name.length > 40 ||
			typeof region.mainAddress !== "string" ||
			typeof region.gameAddress !== "string" ||
			typeof region.offset !== "number" ||
			!Number.isInteger(region.offset) ||
			region.offset < 0 ||
			!region.gameAddress.includes("<gameID>")
		)
			throw new Error(`Invalid region: ${id}`);
		const main = new URL(region.mainAddress),
			game = new URL(region.gameAddress.replace("<gameID>", "1"));
		if (
			!["http:", "https:"].includes(main.protocol) ||
			!["ws:", "wss:"].includes(game.protocol) ||
			main.username ||
			main.password ||
			game.username ||
			game.password
		)
			throw new Error(`Invalid region URL: ${id}`);
		result[id] = {
			name: region.name,
			mainAddress: region.mainAddress,
			gameAddress: region.gameAddress,
			offset: region.offset,
			...(typeof region.flag === "string" ? { flag: region.flag } : {}),
		};
	}
	return result;
}
